export default "__VITE_ASSET__BVtXPjPi__"